class CustomTrackers {
  constructor() {
    this.headerPhoneLink = document.querySelector('#header-phone-link');
    this.footerPhoneLink = document.querySelector('.footer_text_contact li a');
    this.contactUsPagePhoneLink = document.querySelector('a[title="tel:0413 054 578"]');

    this.headerEmailLink = document.querySelector('#header-email-link');
    this.footerEmailLink = document.querySelectorAll('.footer_text_contact li a')[1];
    this.contactUsPageEmailLink = document.querySelector('a[title="mailto:erin@nurtureparenting.com.au"]');

    this.bindEvents();
  }

  handleHeaderPhoneLinkClicked() {
    e.stopPropagation();
    e.preventDefault();

    try {
      gtag('config', 'AW-958609179/9lumCO3Dq_cDEJvujMkD', {
        'phone_conversion_number': '0413 054 578'
      });

      window.location.href = this.headerPhoneLink.href;
    } catch (error) {
      window.location.href = this.headerPhoneLink.href;
    }
  }

  handleFooterPhoneLinkClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    try {
      gtag('config', 'AW-958609179/8uxLCMSS6fcDEJvujMkD', {
        'phone_conversion_number': '0413 054 578'
      });

      window.location.href = this.footerPhoneLink.href;
    } catch (error) {
      window.location.href = this.footerPhoneLink.href;
    }
  }

  handleContactUsPagePhoneLinkClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    try {
      gtag('config', 'AW-958609179/vrybCJmUrPcDEJvujMkD', {
        'phone_conversion_number': '0413 054 578'
      });

      window.location.href = this.contactUsPagePhoneLink.href;
    } catch (error) {
      window.location.href = this.contactUsPagePhoneLink.href;
    }
  }

  handleHeaderEmailLinkClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    try {
      const callback = () => {
        window.location.href = this.headerEmailLink.href;
      };

      gtag('event', 'conversion', {
        'send_to': 'AW-958609179/2ky7COnW74oYEJvujMkD',
        'event_callback': callback
      });
    } catch (error) {
      window.location.href = this.headerEmailLink.href;
    }
  }

  handleFooterEmailLinkClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    try {
      const callback = () => {
        window.location.href = this.footerEmailLink.href;
      };

      gtag('event', 'conversion', {
        'send_to': 'AW-958609179/lpRQCMLz7YoYEJvujMkD',
        'event_callback': callback
      });
    } catch (error) {
      window.location.href = this.footerEmailLink.href;
    }
  }

  handleContactUsPageEmailLinkClicked(e) {
    e.stopPropagation();
    e.preventDefault();

    try {
      const callback = () => {
        window.location.href = this.contactUsPageEmailLink.href;
      };

      gtag('event', 'conversion', {
        'send_to': 'AW-958609179/mN4ACMfq8IoYEJvujMkD',
        'event_callback': callback
      });
    } catch (error) {
      window.location.href = this.contactUsEmailLink.href;
    }
  }

  bindEvents() {
    document.addEventListener('tidioChat-ready', function () {
      window.tidioChatApi.on('open', (e) => {
        gtag('event', 'conversion', {
          'send_to': 'AW-958609179/6n6rCIL77YoYEJvujMkD',
          'event_callback': () => { }
        });
      });
    });

    this.headerPhoneLink.addEventListener('click', (e) => {
      this.handleHeaderPhoneLinkClicked(e);
    });

    this.footerPhoneLink.addEventListener('click', (e) => {
      this.handleFooterPhoneLinkClicked(e);
    });

    if (this.contactUsPagePhoneLink) {
      this.contactUsPagePhoneLink.addEventListener('click', (e) => {
        this.handleContactUsPagePhoneLinkClicked(e);
      });
    }

    this.headerEmailLink.addEventListener('click', (e) => {
      this.handleHeaderEmailLinkClicked(e);
    });

    this.footerEmailLink.addEventListener('click', (e) => {
      this.handleFooterEmailLinkClicked(e);
    });

    if (this.contactUsPageEmailLink) {
      this.contactUsPageEmailLink.addEventListener('click', (e) => {
        this.handleContactUsPageEmailLinkClicked(e);
      });
    }
  }
}

$(document).ready(function () {
  new CustomTrackers();
});
